import React, { Component } from 'react';
import { Container, Row, Col, Input, Table, Button } from 'reactstrap';
import AdminFunctions from './AdminFunctions';
import utilities from '../util/utilities';
import { FaSort } from 'react-icons/fa';
import apiFetch from '../services/ApiClient';
import '../layout/site.css';

export class Users extends Component {
    static displayName = Users.name;

    constructor(props) {
        super(props);

        this.state = {
            users: [],
            search: null,
            height: 0,
            width: 0,
            sort: {
                column: null,
                direction: 'desc'
            },
            error: null
        };

        window.addEventListener('resize', this.setWindowDimensions);
    }

    async componentDidMount() {
        const isAdmin = await AdminFunctions.isAdminAsync();
        if (!isAdmin) {
            this.props.history.push('/accessdenied');
            return;
        }

        this.setWindowDimensions();
        await this.getUsers();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.setWindowDimensions);
    }

    render() {
        return (
            <div>
                <Container className='container-main'>
                    <Row>
                        <Col>
                            <h3>Users</h3>
                        </Col>
                    </Row>

                    <Row className='row-20'>
                        <Col xl='6' lg='6' md='6' sm='12' xs='12'>
                            <Input
                                type='text'
                                onChange={(e) => this.setState({ search: e.target.value })}
                                name='search'
                                id='search'
                                placeholder='Search'
                                style={this.state.width < utilities.dimensions.LG ? { marginBottom: '20px' } : {}}
                            />
                        </Col>

                        <Col xl='3' lg='3' md='3' sm='6' xs='6'>
                            <Button
                                color='primary'
                                onClick={() => this.searchUsers()}
                                style={this.state.width < utilities.dimensions.MD ? { marginBottom: '20px' } : {}}
                            >
                                Search
                            </Button>
                        </Col>

                        <Col xl='3' lg='3' md='3' sm='6' xs='6'>
                            <Button
                                color='primary'
                                onClick={() =>
                                    this.props.history.push({
                                        pathname: '/admin/users/details',
                                        state: { existingUser: false }
                                    })
                                }
                                style={{ whiteSpace: 'nowrap' }}
                            >
                                + Add
                            </Button>
                        </Col>
                    </Row>

                    {this.state.error && (
                        <Row className='row-10'>
                            <Col>
                                <div className="alert alert-danger">{this.state.error}</div>
                            </Col>
                        </Row>
                    )}

                    <Row className='row-20'>
                        <Col>
                            <Table bordered hover>
                                <thead>
                                    <tr>
                                        <th>
                                            Last Name
                                            <FaSort
                                                color={this.state.sort.column === 'lastName' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('lastName')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th>
                                            First Name
                                            <FaSort
                                                color={this.state.sort.column === 'firstName' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('firstName')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th>
                                            Office Phone
                                            <FaSort
                                                color={this.state.sort.column === 'officePhone' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('officePhone')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th>
                                            Email
                                            <FaSort
                                                color={this.state.sort.column === 'email' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('email')}
                                                className='sort-button'
                                            />
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.users.map((user) => {
                                        return (
                                            <tr key={user.id} onClick={() => this.handleRowClick(user.id)}>
                                                <td>{user.lastName}</td>
                                                <td>{user.firstName}</td>
                                                <td>{user.officePhone}</td>
                                                <td>{user.email}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }

    extractApiErrorMessage(data, fallback) {
        // ApiErrorDto: { code, message, correlationId }
        if (!data) return fallback;
        if (typeof data === 'string') return data;
        if (data.message) return data.message;
        return fallback;
    }

    async getUsers() {
        this.setState({ error: null });

        const r = await apiFetch(`/api/Admin/GetUsersAsync`, { method: 'GET' });

        if (r.status === 401) {
            this.props.history.push('/login');
            return;
        }
        if (r.status === 403) {
            this.props.history.push('/accessdenied');
            return;
        }
        if (!r.ok) {
            this.setState({ error: this.extractApiErrorMessage(r.data, 'Failed to load users.') });
            return;
        }

        this.setState({ users: Array.isArray(r.data) ? r.data : [] });
    }

    async searchUsers() {
        this.setState({ error: null });

        const query = this.state.search || '';
        const r = await apiFetch(`/api/Admin/SearchUsersAsync?query=${encodeURIComponent(query)}`, { method: 'GET' });

        if (r.status === 401) {
            this.props.history.push('/login');
            return;
        }
        if (r.status === 403) {
            this.props.history.push('/accessdenied');
            return;
        }
        if (!r.ok) {
            this.setState({ error: this.extractApiErrorMessage(r.data, 'Failed to search users.') });
            return;
        }

        this.setState({ users: Array.isArray(r.data) ? r.data : [] });
    }

    handleRowClick(userId) {
        this.props.history.push({
            pathname: '/admin/users/details',
            state: { userId: userId, existingUser: true }
        });
    }

    setWindowDimensions = () => {
        this.setState({
            height: window.innerHeight,
            width: window.innerWidth
        });
    };

    handleSort(column) {
        const direction = this.state.sort.column
            ? this.state.sort.direction === 'asc'
                ? 'desc'
                : 'asc'
            : 'desc';

        const data = [...this.state.users];
        data.sort((a, b) => (a[column] ?? '').localeCompare(b[column] ?? ''));

        if (direction === 'desc') data.reverse();

        this.setState({
            users: data,
            sort: { column, direction }
        });
    }
}